import actionTypes from '../constants/action-types';

const setSettings = (settings) => ({
  type: actionTypes.SET_INTEGRATION_SETTINGS,
  payload: {
    settings,
  },
});

export default setSettings;
